<template>
    <div>
        <SectionTitle
            :has-line="true"
            content="Historial de Enmiendas"
        />
        
        <custom-callout
            v-for="historyRow in history"
            class="mb-3"
            :has-toggle="false"
        >
            <div class="row">
                <div class="col-3">
                    <span class="font-14 color-secondary-6">Número de Consulta:</span><br>
                    {{ historyRow.businessId }}
                </div>
                <div class="col-2">
                    <span class="font-14 color-secondary-6">Tipo de Consulta:</span><br>
                    {{ historyRow.requestTypeName }}
                </div>
                <div class="col-2">
                    <span class="font-14 color-secondary-6">Determinación:</span><br>
                    {{ historyRow.determinationName }}
                </div>
                <div class="col-3">
                    <span class="font-14 color-secondary-6">Escuela:</span><br>
                    {{ historyRow.schoolName }}
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <ActionButton
                        text="Ver Detalle"
                        i="fa fa-file-search"
                        variant="outline-success"
                        @click="detailRedirect(historyRow.id)"
                    />
                </div>
            </div>
        </custom-callout>
    </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import { ActionButton } from "@/components/common";
import CustomCallout from "@/components/common/CustomCallout";
import { getAmendmentHistory } from '@/services/api/tapRequest.api';

export default {
    name: 'AmendmentHistory',
    components: {
        SectionTitle,
        ActionButton,
        CustomCallout,
    },
    data: () => ({
        history: [],
    }),
    methods: {
        detailRedirect(tapRequestId) {
            this.$router.push({ 
                name: 'uta-management', 
                params: { tapRequestId: tapRequestId } 
            });
        }
    },
    async mounted() {
        const { data } = await getAmendmentHistory(this.$route.params.tapRequestId);
        this.history = [...data];
    },
};
</script>
